import React, { useCallback, useState } from 'react';
import { Box } from '@common-fe/common-fe';

import ROUTES from '@/common/routes';
import { PreventLeaveModal } from '@/modules/core/components';
import { useHistory } from '@/modules/core/hooks';

import { InvestmentPaths } from '../../investments.types';
import SelfDirectedWrapper from '../SelfDirectedWrapper';

import QuestionnaireFields from './QuestionnaireFields';

interface Props {
  accountId: string;
  investorId: string;
  isSwitchMode?: boolean;
  isEmptyProfileMode?: boolean;
}
const Questionnaire: React.FC<Props> = ({ accountId, investorId, isSwitchMode, isEmptyProfileMode }) => {
  const [isPreventLeave, setPreventLeave] = useState(true);
  const history = useHistory();
  const handleNext = useCallback(() => {
    setPreventLeave(false);
    if (isSwitchMode) {
      if (isEmptyProfileMode) {
        history.push(`${ROUTES.SELF_DIRECTED_EMPTY_SWITCH_SELECT(accountId)}?investorId=${investorId}`);
      } else {
        history.push(ROUTES.SELF_DIRECTED_SWITCH_SELECT(accountId));
      }
    } else {
      history.push(`${ROUTES.SELF_DIRECTED(accountId)}?investorId=${investorId}`);
    }
  }, [accountId, history, investorId, isEmptyProfileMode, isSwitchMode]);
  const handleBack = useCallback(() => {
    if (isEmptyProfileMode) {
      history.goBack();
    } else {
      history.push(`${ROUTES.START_INVESTING}?accountId=${accountId}&investorId=${investorId}`);
    }
  }, [accountId, history, investorId, isEmptyProfileMode]);

  return (
    <SelfDirectedWrapper
      isSwitchMode={isSwitchMode}
      isEmptyPortfolioMode={isEmptyProfileMode}
      currentStep={isSwitchMode ? 1 : 2}
    >
      {isSwitchMode && <PreventLeaveModal isPrevent={isPreventLeave} />}
      <Box direction="column" data-testid="PortfolioQuestionnaire-wrapper">
        <QuestionnaireFields
          isSwitchMode={isSwitchMode}
          investmentType={InvestmentPaths.SELF_DIRECTED}
          onSubmit={handleNext}
          onBack={handleBack}
        />
      </Box>
    </SelfDirectedWrapper>
  );
};

export default Questionnaire;
